enum LedgerState {
    Active = "ACTIVE",
    Closed = "CLOSED"
}
export default LedgerState